import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, State } from '../reducers/start.reducer';

export const selectFeatureState = createFeatureSelector<State>(featureKey);

export const isLoading = createSelector(selectFeatureState, ({loading}): boolean => !!loading);
